// extracted by mini-css-extract-plugin
export default {"mCard":"kA-z","image":"lA-z","imageNoBackground":"mA-z","imageHasCategory":"nA-z","fullWidth":"oA-z"};